export default class Charge {
    public impfstoffcharge_id: number | null = null;
    public impfstoff_id: number | null = null;
    public impfstelle_id: number | null = null;
    public eingangsdatum: string | null = null;
    public chargennr: string | null = null;
    public lagerbestand: number | null = null;
    public ablaufdatum: string | null = null;
    public lieferant: string | null = null;
    public lieferscheinnr: string | null = null;
    public lieferscheindatum: string | null = null;
    public rechnungsdatum: string | null = null;
    public einkaufspreis: number | null = null;
    public anmerkung: string | null = null;

    constructor(data?: Partial<Charge>) {
        Object.assign(this, data);
    }
}
